module.exports = __webpack_public_path__ + "img/Logo.700fb8ef.png";